declare const jQuery: any;
const $ = jQuery;

import { getCookie, setCookie } from "./cookies";
import * as classnames from "classnames";
import { logObj } from "./utils/misc";

const defaultEventName: string = "click";//("ontouchstart" in window) ? "touchstart" : "click"; //fixme find out why touchstart fails sometimes

export function initAllPopups(): void
{
	if (window["IW_DISABLE_POPUPS"])
	{
		return;
	}
	$(function ($) {
		initPopups($(`[data-popup]`));
	});
}

export function initAllPopupBtns()
{
	const $btns = $(`[data-popup-btn]`);
	if ($btns.length > 0)
	{
		const onClick = function () {
			const $btn = $(this);
			const id: string = $btn.attr("data-popup-btn");
			const $popup = $(`[data-popup="${id}"]`).first();
			if ($popup.length === 0)
			{
				console.error(`Popup btn with popup id '${id}' has no popup`);
				return;
			}
			const popupData: string = $btn.attr("data-popup-data");
			if ($btn.is(`[data-toggle]`))
			{
				togglePopup($popup, popupData);
			}
			else
			{
				showPopup($popup, popupData);
			}
			return false;
		};
		$btns.each(function () {
			const $btn = $(this);
			const eventName: string = $btn.is("[data-force-use-click-trigger]") ? "click" : defaultEventName;
			$btn.on(eventName, onClick);
		});
	}
	
	$(`a[href^="#popup-"]`).on(defaultEventName, function () {
		const $a = $(this);
		const elId: string = $a.attr("href").replace(/^\#/, "");
		if (document.getElementById(elId))
		{
			return;
		}
		const id: string = elId.replace(/^popup\-/, "");
		const $popup = $(`[data-popup="${id}"]`).first();
		if ($popup.length === 0)
		{
			console.error(`Popup <a> with href #${elId} has no popup`);
			return;
		}
		const popupData: string = $a.attr("data-popup-data");
		showPopup($popup, popupData);
		return false;
	});
}

function popupShouldCloseOthers($popup): boolean
{
	return $popup.is("[data-popup-close-others]");
}

function initPopups($popups): void
{
	$popups.on("open", function popupOpen(event, data) {
		showPopup($(this), data);
	}).on("close", function popupClose() {
		hidePopup($(this));
	});
	$popups.find(`[data-popup-close]`).on(defaultEventName, function (ev) {
		const $popup = $(this).closest(`[data-popup]`);
		hidePopup($popup);
	});
	$popups.filter(`[data-auto-open-delay]`).each(function () {
		const $popup = $(this);
		const popupId: string = $popup.attr("data-popup");
		if (timedPopupWasDismissed(popupId))
		{
			return;
		}
		const delayMSecs: number = (parseInt($popup.attr("data-auto-open-delay"), 10) || 0) * 1000;
		setTimeout(function () {
			showPopup($popup);
		}, delayMSecs);
	}).on("closed", function () {
		// set cookie to remember being dismissed
		const $popup = $(this);
		const popupId: string = $popup.attr("data-popup");
		const cookieName: string = "tpu_dismiss_" + popupId;
		setCookie(cookieName, "1");
	});
	// Prevent internal items' 'open' & 'close' events causing unexpected behaviour
	$popups.children().on("open close", function (event) {
		event.stopPropagation();
	});
	// Browser history
	$popups.filter(`[data-popup-history]`).on("opening", function () {
		setupHistoryPopupState();
		const $popup = $(this);
		const popupId: string = $popup.attr("data-popup");
		pushHistory(popupId);
	}).on("closing", function () {
		const $popup = $(this);
		const popupId: string = $popup.attr("data-popup");
		const history: boolean = $popup.is("[data-popup-history]");
		if (history)
		{
			popHistory(popupId);
		}
	});
}

const historyPushedPopupIds: string[] = [];

function pushHistory(popupId: string): void
{
	if (!window.history || !window.addEventListener)
	{
		return;
	}
	historyPushedPopupIds.push(popupId);
	window.history.pushState({ popupId }, null, "#!" + popupId);
}

function popHistory(popupId: string): void
{
	if (!window.history || !window.addEventListener)
	{
		return;
	}
	if (popupId !== historyPushedPopupIds[historyPushedPopupIds.length - 1])
	{
		return;
	}
	historyPushedPopupIds.pop();
	window.history.back();
}

let _historyPopStateSetup = false;
function setupHistoryPopupState(): void
{
	if (_historyPopStateSetup)
	{
		return;
	}
	_historyPopStateSetup = true;
	window.addEventListener("popstate", function (event) {
		const popupId: string = historyPushedPopupIds.pop();
		if (popupId)
		{
			const $popup = $(`[data-popup="${popupId}"]`);
			if ($popup.hasClass("show"))
			{
				$popup.trigger("close");
			}
		}
		else
		{
			const popupId: string = (window.location.hash || "").replace(/^\#\!/, "");
			if (!popupId || popupId.match(/\#/))
			{
				return;
			}
			const $popup = $(`[data-popup="${popupId}"][data-popup-history]`);
			if ($popup.length === 1)
			{
				$popup.trigger("open");
				historyPushedPopupIds.push(popupId);
			}
		}
	});	
}

function timedPopupWasDismissed(popupId: string): boolean
{
	const cookieName: string = "tpu_dismiss_" + popupId;
	return !!getCookie(cookieName);
}

function closeOtherPopups($popup): void
{
	$(`[data-popup]`).not($popup).each(function () {
		hidePopup($(this));
	});
}

function showPopup($popup, popupData?: any): void
{
	if ($popup.length === 0)
	{
		console.error(`showPopup passed empty JQuery $popup`);
		return;
	}
	if (popupShouldCloseOthers($popup))
	{
		const delay: number = $popup.is("[data-popup-close-others-delay]") ? 800 : 0;
		setTimeout(() => {
			closeOtherPopups($popup);
		}, delay);
	}
	const display: string = $popup.attr("data-css-display") || "block";
	$popup.css({ display }).removeClass("too-tall").trigger("opening", { popupData });
	const $inner = $popup.find(".popup-main").children();
	setTimeout(function () {
		$popup.addClass("show");
		if ($inner.outerHeight() >= $popup.outerHeight())
		{
			$popup.addClass("too-tall");
		}
		$popup.find("[autofocus]").first().focus();
		const popupId: string = $popup.attr("data-popup");
		$("body").addClass(`popup-open popup-open-${popupId}`);
		$popup.trigger("opened", { popupData });
	}, 40);
}

function hidePopup($popup): void
{
	if (!$popup.hasClass("show"))
	{
		return;
	}
	$popup.trigger("closing").removeClass("show").removeClass("too-tall");
	const popupId: string = $popup.attr("data-popup");
	$("body").removeClass(`popup-open popup-open-${popupId}`);
	setTimeout(function () {
		$popup.css({ display: "none" }).trigger("closed");
	}, 650);
}

function hideAllPopups(): void
{
	$(`[data-popup]`).each(function () {
		hidePopup($(this));
	});
}

function togglePopup($popup, popupData: any): void
{
	if ($popup.hasClass("show"))
	{
		hidePopup($popup);
	}
	else
	{
		showPopup($popup, popupData);
	}
}

export interface DynamicPopupSettings
{
	content: any; // HTML/jQuery/DOMElement
	popupId?: string;
	className?: string|string[];
	heading?: string;
	putCloseBtn?: boolean; // default true
	autoOpenDelay?: number; // milliseconds before auto-open
	closeOthersOnOpen?: boolean; // whether to close other popups on open
	history?: boolean; // so 'back' btn closes popup.
}

// Creates a new popup on the fly and appends it to <body>.
// Returns jQuery for popup.
// To open/close it, fire open/close events on the returned jQuery object.
export function createDynamicPopup(settings: DynamicPopupSettings)
{
	const popupId: string = settings.popupId || getDynamicPopupId();
	const $popup = $(`<div>`).attr("data-popup", popupId);
	if (settings.autoOpenDelay)
	{
		$popup.attr("data-auto-open-delay", settings.autoOpenDelay);
	}
	if (settings.closeOthersOnOpen)
	{
		$popup.attr("data-popup-close-others", "");
	}
	if (settings.history)
	{
		$popup.attr("data-popup-history", "");
	}
	$popup.addClass(classnames("popup", `popup-${popupId}`, settings.className));
	const $main = $(`<div class="popup-main">`).appendTo($popup);
	const $mainInner = $(`<div>`).appendTo($main);
	if (settings.heading)
	{
		$mainInner.append(`<header><h2>${settings.heading}</h2></header>`);
	}
	const $content = $(`<div class="popup-content">`).append(settings.content);
	$mainInner.append($content);
	if (settings.putCloseBtn || settings.putCloseBtn === undefined)
	{
		$popup.append(`<div class="popup-close-wrap"><div class="popup-close" data-popup-close=""></div></div>`);
	}
	$("body").append($popup);
	initPopups($popup);
	return $popup;
}

// Returns $popup or undefined if not found
function openPopupById(popupId: string, popupData?: any): any
{
	const $popup = $(`[data-popup="${popupId}"]`);
	if ($popup.length === 0)
	{
		return undefined;
	}
	showPopup($popup, popupData);
	return $popup;
}

// Returns $popup or undefined if not found
function togglePopupById(popupId: string, popupData?: any): any
{
	const $popup = $(`[data-popup="${popupId}"]`);
	if ($popup.length === 0)
	{
		return undefined;
	}
	togglePopup($popup, popupData);
	return $popup;
}

let dynamicPopupIdCounter = 0;
function getDynamicPopupId(): string
{
	++dynamicPopupIdCounter;
	return `popup_` + dynamicPopupIdCounter;
}

if (!window["iw"])
{
	window["iw"] = {};
}

window["iw"].popups = {
	createDynamicPopup,
	openPopupById,
	togglePopupById,
	hideAllPopups
};
